export default __webpack_public_path__ + "static/media/home.02962268.svg";